import { render, staticRenderFns } from "./EndpointList.vue?vue&type=template&id=c8c102e6&scoped=true"
import script from "./EndpointList.vue?vue&type=script&lang=js"
export * from "./EndpointList.vue?vue&type=script&lang=js"
import style0 from "./EndpointList.vue?vue&type=style&index=0&id=c8c102e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c102e6",
  null
  
)

export default component.exports